export enum ModulesDefinition {
  usersSettings = 'Ustawienia Administratorów',
  contentSettings = 'Ustawienia treści',
  news = 'Aktualności',
  fertilizers = 'Nawozy',
  knowledge = 'Wiedza',
  video = 'Video',
  multimedia = 'Multimedia',
  products = 'Produkty',
  nawozyTV = 'Nawozy TV',
  fertilization = 'Nawożenie upraw',
  fertilizationSchedule = 'Harmonogramy nawożenia',
  information = 'Informacje ogólne',
  contact = 'Kontakt',
  banners = 'Reklamy banerowe',
  askExpert = 'Zapytaj eksperta',
  gtw = 'Grunt to Wiedza',
  garden = 'Nawozy GARDEN',
}

export const modulesList = [
  {
    title: 'Ustawienia Administratorów',
    id: ModulesDefinition.usersSettings,
  },
  {
    title: 'Ustawienia treści',
    id: ModulesDefinition.contentSettings,
  },
  {
    title: 'Aktualności',
    id: ModulesDefinition.news,
  },
  {
    title: 'Wiedza',
    id: ModulesDefinition.knowledge,
  },
  {
    title: 'Nawozy',
    id: ModulesDefinition.fertilizers,
  },
  {
    title: 'Nawozy GARDEN',
    id: ModulesDefinition.garden,
  },
  {
    title: 'Informacje ogólne',
    id: ModulesDefinition.information,
  },
  {
    title: 'Grunt to Wiedza',
    id: ModulesDefinition.gtw,
  },
  {
    title: 'Reklamy banerowe',
    id: ModulesDefinition.banners,
  },
  {
    title: 'Kontakt',
    id: ModulesDefinition.contact,
  },
];

export enum NewsSubModuleDefinition {
  showNews = 'showNews',
  addNews = 'addNews',
  fieldNews = 'fieldNews',
  addFieldNews = 'addFieldNews',
}

export enum SettingsSubModuleDefinition {
  usersList = 'usersList',
  addUser = 'addUser',
}

export enum ContactSubModuleDefinition {
  representativesList = 'representativesList',
  representativesAdd = 'representativesAdd',
  distribution = 'distribution',
  distributionAdd = 'distributionAdd',
  dataProtection = 'dataProtection',
  rules = 'rules',
  privacy = 'privacy',
  serviceMap = 'serviceMap',
}

export enum ContentSettingsSubModuleDefinition {
  newsCategoriesAdd = 'newsCategoriesAdd',
  newsCategoriesList = 'newsCategoriesList',
  allCategoriesAdd = 'allCategoriesAdd',
  allCategoriesList = 'allCategoriesList',
  sectionsAdd = 'sectionsAdd',
  sectionsList = 'sectionsList',
  fertilizersCategoriesAdd = 'fertilizersCategoriesAdd',
  fertilizersCategories = 'fertilizersCategories',
  fertilizersPackAdd = 'fertilizersPackAdd',
  fertilizersPack = 'fertilizersPack',
  gtwCatAdd = 'gtwCatAdd',
  gtwCat = 'gtwCat',
}

export enum GtwSubModuleDefinition {
  gtwArtAdd = 'gtwArtAdd',
  gtwArt = 'gtwArt',
  gtwRequirementsAdd = 'gtwRequirementsAdd',
  gtwRequirements = 'gtwRequirements',
  gtwFilesAdd = 'gtwFilesAdd',
  gtwFiles = 'gtwFiles',
  gtwEditionsAdd = 'gtwEditionsAdd',
  gtwEditions = 'gtwEditions',
}

export const newsModulesList = [
  {
    id: NewsSubModuleDefinition.addNews,
    title: 'Newsy +',
    category: ModulesDefinition.news,
  },
  {
    id: NewsSubModuleDefinition.showNews,
    title: 'Newsy',
    category: ModulesDefinition.news,
  },
  {
    id: NewsSubModuleDefinition.addFieldNews,
    title: 'Wiadomości terenowe +',
    category: ModulesDefinition.news,
  },
  {
    id: NewsSubModuleDefinition.fieldNews,
    title: 'Wiadomości terenowe',
    category: ModulesDefinition.news,
  },
];

export const gtwModulesList = [
  {
    id: GtwSubModuleDefinition.gtwArtAdd,
    title: 'Baza wiedzy +',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwArt,
    title: 'Baza wiedzy',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwRequirementsAdd,
    title: 'Edycje warunki +',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwRequirements,
    title: 'Edycje warunki',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwFilesAdd,
    title: 'Edycje pliki +',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwFiles,
    title: 'Edycje pliki',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwEditionsAdd,
    title: 'Edycje +',
    category: ModulesDefinition.gtw,
  },
  {
    id: GtwSubModuleDefinition.gtwEditions,
    title: 'Edycje',
    category: ModulesDefinition.gtw,
  },
];

export const contentSettingsModulesList = [
  {
    id: ContentSettingsSubModuleDefinition.newsCategoriesAdd,
    title: 'Newsy +',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.newsCategoriesList,
    title: 'Newsy',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.allCategoriesAdd,
    title: 'Porady, wiadomości, TV +',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.allCategoriesList,
    title: 'Porady, wiadomości, TV',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.sectionsAdd,
    title: 'Wiadomości regiony +',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.sectionsList,
    title: 'Wiadomości regiony',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.fertilizersCategoriesAdd,
    title: 'Nawozy +',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.fertilizersCategories,
    title: 'Nawozy',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.fertilizersPackAdd,
    title: 'Opakowania +',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.fertilizersPack,
    title: 'Opakowania',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.gtwCatAdd,
    title: 'Baza wiedzy +',
    category: ModulesDefinition.contentSettings,
  },
  {
    id: ContentSettingsSubModuleDefinition.gtwCat,
    title: 'Baza wiedzy',
    category: ModulesDefinition.contentSettings,
  },
];

export const settingsModulesList = [
  {
    id: SettingsSubModuleDefinition.addUser,
    title: 'Administratorzy +',
    category: ModulesDefinition.usersSettings,
  },
  {
    id: SettingsSubModuleDefinition.usersList,
    title: 'Administratorzy',
    category: ModulesDefinition.usersSettings,
  },
];

export const contactModulesList = [
  {
    id: ContactSubModuleDefinition.representativesAdd,
    title: 'Przedstawiciele terenowi +',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.representativesList,
    title: 'Przedstawiciele terenowi',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.distributionAdd,
    title: 'Punkty dystrybucji +',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.distribution,
    title: 'Punkty dystrybucji',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.dataProtection,
    title: 'Ochrona danych osobowych',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.rules,
    title: 'Regulamin i polityka cookies',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.privacy,
    title: 'Polityka prywatności',
    category: ModulesDefinition.contact,
  },
  {
    id: ContactSubModuleDefinition.serviceMap,
    title: 'Mapa serwisu',
    category: ModulesDefinition.contact,
  },
];

export enum NawozyTVSubModuleDefinition {
  showNawozyTV = 'Lista artykułów',
  addNawozyTV = 'Dodaj wpis',
}

export enum FertilizationSubModuleDefinition {
  showFertilization = 'Nawożenie upraw',
}

export enum FertilizationScheduleSubModuleDefinition {
  showFertilizationSchedule = 'Harmonogramy nawożenia',
}

export enum ExpertArticlesSubModuleDefinition {
  showExpertArticles = 'Porady ekspertów',
  addExpertArticles = 'Dodaj poradę',
  expertArticlesCategory = 'Kategorie porad',
  addExpertArticlesCategory = 'Dodaj kategorię porad',
}

export enum GallerySubModuleDefinition {
  showGallery = 'Galeria obrazków',
  pictureCategory = 'Kategorie obrazków',
  addPicture = 'Dodaj obrazek',
}

export enum KnowledgeSubModuleDefinition {
  knowledge = 'knowledge',
  addKnowledge = 'addKnowledge',
  addNawozyTV = 'addNawozyTV',
  nawozyTV = 'nawozyTV',
  fertilizationAdd = 'fertilizationAdd',
  fertilization = 'fertilization',
  fertilizationScheduleAdd = 'fertilizationScheduleAdd',
  fertilizationSchedule = 'fertilizationSchedule',
  askExpert = 'askExpert',
  askExpertAdd = 'askExpertAdd',
  AGROlider = 'AGROlider',
  AGROliderAdd = 'AGROliderAdd',
}

export enum FertilizersSubModuleDefinition {
  fertilizersAdd = 'fertilizersAdd',
  fertilizers = 'fertilizers',
  fertilizersParametersAdd = 'fertilizersParametersAdd',
  fertilizersParameters = 'fertilizersParameters',
  fertilizersDictionary = 'fertilizersDictionary',
}

export enum GardenSubModuleDefinition {
  gardenExpertArticlesAdd = 'gardenExpertArticlesAdd',
  gardenExpertArticles = 'gardenExpertArticles',
  gardenFertilizersAdd = 'gardenFertilizersAdd',
  gardenFertilizers = 'gardenFertilizers',
  gardenFertilizersDictionary = 'gardenFertilizersDictionary',
}

export const FertilizersModulesList = [
  {
    id: FertilizersSubModuleDefinition.fertilizersAdd,
    title: 'Nawozy +',
    category: ModulesDefinition.fertilizers,
  },
  {
    id: FertilizersSubModuleDefinition.fertilizers,
    title: 'Nawozy',
    category: ModulesDefinition.fertilizers,
  },
  {
    id: FertilizersSubModuleDefinition.fertilizersParametersAdd,
    title: 'Nawozy skład +',
    category: ModulesDefinition.fertilizers,
  },
  {
    id: FertilizersSubModuleDefinition.fertilizersParameters,
    title: 'Nawozy skład',
    category: ModulesDefinition.fertilizers,
  },
  {
    id: FertilizersSubModuleDefinition.fertilizersDictionary,
    title: 'Słowniki',
    category: ModulesDefinition.fertilizers,
  },
];

export const knowledgeModulesList = [
  {
    id: KnowledgeSubModuleDefinition.addKnowledge,
    title: 'Porady ekspertów +',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.knowledge,
    title: 'Porady ekspertów',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.addNawozyTV,
    title: 'Nawozy TV +',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.nawozyTV,
    title: 'Nawozy TV',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.fertilizationAdd,
    title: 'Nawożenie upraw +',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.fertilization,
    title: 'Nawożenie upraw',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.fertilizationScheduleAdd,
    title: 'Harmonogramy +',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.fertilizationSchedule,
    title: 'Harmonogramy',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.askExpertAdd,
    title: 'Zapytaj eksperta +',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.askExpert,
    title: 'Zapytaj eksperta',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.AGROliderAdd,
    title: 'AGROlider +',
    category: ModulesDefinition.knowledge,
  },
  {
    id: KnowledgeSubModuleDefinition.AGROlider,
    title: 'AGROlider',
    category: ModulesDefinition.knowledge,
  },
];

export const GardenModulesList = [
  {
    id: GardenSubModuleDefinition.gardenExpertArticlesAdd,
    title: 'Porady GARDEN +',
    category: ModulesDefinition.garden,
  },
  {
    id: GardenSubModuleDefinition.gardenExpertArticles,
    title: 'Porady GARDEN',
    category: ModulesDefinition.garden,
  },
  {
    id: GardenSubModuleDefinition.gardenFertilizersAdd,
    title: 'Nawozy GARDEN +',
    category: ModulesDefinition.garden,
  },
  {
    id: GardenSubModuleDefinition.gardenFertilizers,
    title: 'Nawozy GARDEN',
    category: ModulesDefinition.garden,
  },
  {
    id: GardenSubModuleDefinition.gardenFertilizersDictionary,
    title: 'Słowniki',
    category: ModulesDefinition.garden,
  },
];

export enum VideoSubModuleDefinition {
  video = 'Filmy',
  addVideo = 'Dodaj video',
}

export enum MultimediaModuleDefinition {
  addMultimedia = 'Dodaj wpis',
  multimedia = 'Multimedia',
}

export enum LexiconModuleDefinition {
  lexicon = 'Leksykon Nawożenia',
  addLexicon = 'Dodaj leksykon',
  lexiconCategories = 'Kategorie leksykonów',
  lexiconCategoriesAdd = 'Dodaj kategorię leksykonów',
}

export enum ProductsModuleDefinition {
  products = 'Lista produktów',
  addProduct = 'Dodaj produkt',
  productsCategories = 'Kategorie produktów',
  addProductsCategories = 'Dodaj kategorię',
}

export enum NawozyTVModuleDefinition {
  nawozyTV = 'nawozyTV',
  addNawozyTV = 'addNawozyTV',
}

export const allModulesList = [
  ...knowledgeModulesList,
  ...settingsModulesList,
  ...newsModulesList,
  ...contentSettingsModulesList,
  ...contactModulesList,
  ...FertilizersModulesList,
  ...GardenModulesList,
  {
    title: 'Reklamy banerowe',
    id: 'banners',
    category: 'banners',
  },
];
